var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216,432c0,17.648,14.352,32,32,32s32-14.352,32-32s-14.352-32-32-32S216,414.352,216,432z M264,432 c0,8.824-7.176,16-16,16c-8.824,0-16-7.176-16-16c0-8.824,7.176-16,16-16C256.824,416,264,423.176,264,432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.824,113.432C420.4,50.304,367.968,0,304,0c-43.208,0-83.328,23.752-104.464,61.168 C192.208,57.776,184.208,56,176,56c-19.608,0-37.688,10.344-47.776,26.848C120.32,80.952,112.192,80,104,80 C46.656,80,0,126.656,0,184s46.656,104,104,104h120v35.32c-37.456,10.6-64,45.208-64,84.68c0,48.52,39.48,88,88,88 s88-39.48,88-88c0-39.472-26.544-74.08-64-84.68V288h136c48.52,0,88-39.48,88-88C496,156.952,465.432,120.904,423.824,113.432z  M256,240v96.152l6.408,1.304C295.776,344.224,320,373.896,320,408c0,39.704-32.304,72-72,72s-72-32.296-72-72 c0-34.104,24.224-63.776,57.592-70.544l6.408-1.304V160h56v16h-40v48h40v16H256z M408,272H272v-16h40v-48h-40v-16h40v-48h-88v128 H104c-48.52,0-88-39.48-88-88s39.48-88,88-88c8.824,0,17.544,1.312,25.928,3.896l6.736,2.08l2.912-6.432 C146.048,81.24,160.344,72,176,72c8.008,0,15.744,2.36,22.352,6.832l7.72,5.208l3.992-8.424C227.208,39.4,264.08,16,304,16 c57.344,0,104,46.656,104.008,103.6l-0.032,8.056l7.208,0.712C452.144,132.024,480,162.824,480,200 C480,239.704,447.696,272,408,272z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 192,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 192,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 192,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 192,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 192,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 16,
    height: 16
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.d7b77c1a19333f097ab36336c6fe09f2.svg";
export { ForwardRef as ReactComponent };